import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './modules/events/events';
import { EventProvider } from './modules/Contexts/EventProvider';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
ReactDOM.createRoot(document.getElementById('react-events')!).render(
    <React.StrictMode>
        <PrimeReactProvider>
        <EventProvider>
            <App />
        </EventProvider>
    </PrimeReactProvider>
    </React.StrictMode>,
)